import { merge } from 'lodash/fp';

import { createDecisions, SemanticDecisions } from '../generator';
import { Decisions } from '../structure';

import { LEGACY_TOKENS } from './light/legacy';
import { ColorSet } from './types';

type DeepPartial<T> = {
    [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

export interface ThemeOverrides {
    decisions?: DeepPartial<SemanticDecisions>;
    components?: DeepPartial<Decisions>;
    legacyPrimaryColorScale?: ColorSet;
}

const getDecisions = (decisions: SemanticDecisions, overrides?: ThemeOverrides) => ({
    ...LEGACY_TOKENS,
    ...createDecisions({
        decisions: merge(decisions, (overrides && overrides.decisions) || {}),
        overrides: (overrides && overrides.components) || {},
    }),
});

export default getDecisions;
